export const ChannelType = {
  Popular: 'popular',
  Recommendation: 'recommendation',
}
export type ChannelTypeType = (typeof ChannelType)[keyof typeof ChannelType]
